import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UploadState {
  uploading: boolean;
  progress: number;
  success: boolean;
  error: string | null;
  analysisId: string | null;
  summary: {
    totalEmployees: number;
    employeesWithViolations: number;
    totalTheftHours: number;
    estimatedLoss: number;
  } | null;
}

const initialState: UploadState = {
  uploading: false,
  progress: 0,
  success: false,
  error: null,
  analysisId: null,
  summary: null,
};

const uploadSlice = createSlice({
  name: 'upload',
  initialState,
  reducers: {
    uploadFileRequest: (state, action: PayloadAction<{ file: File; title: string; description: string }>) => {
      state.uploading = true;
      state.progress = 0;
      state.error = null;
      state.success = false;
    },
    uploadProgress: (state, action: PayloadAction<number>) => {
      state.progress = action.payload;
    },
    uploadFileSuccess: (state, action: PayloadAction<{ analysisId: string; summary: any }>) => {
      state.uploading = false;
      state.progress = 100;
      state.success = true;
      state.analysisId = action.payload.analysisId;
      state.summary = action.payload.summary;
    },
    uploadFileFailure: (state, action: PayloadAction<string>) => {
      state.uploading = false;
      state.progress = 0;
      state.error = action.payload;
      state.success = false;
    },
    resetUpload: (state) => {
      state.uploading = false;
      state.progress = 0;
      state.success = false;
      state.error = null;
      state.analysisId = null;
      state.summary = null;
    },
  },
});

export const {
  uploadFileRequest,
  uploadProgress,
  uploadFileSuccess,
  uploadFileFailure,
  resetUpload,
} = uploadSlice.actions;

export default uploadSlice.reducer;